import {
  BUNDLE_OOS_MESSAGE,
  EXPERIENCE_TYPE_GM,
  UNAVAILABLE_EXPERIENCES,
  ASSORTMENT_STRATEGY
} from '../constants/index';
import { compareString } from './selectable-variant-utils';

export const getExperienceType = (product) => {
  return product?.bundleSpecificationDetails?.experienceType || EXPERIENCE_TYPE_GM;
};

export const getBundleType = (bundle) => bundle?.bundleSpecificationDetails?.type;

export const isProductDiscontinued = ({ product, checkAvailabilityData = null }) => {
  const isDiscontinuedProduct = checkAvailabilityData?.checkAvailability?.fulfillmentOptions?.some(
    (option) => option?.services?.some(
      (service) => service?.deliveryAvailabilityDetail?.some(
        (detail) => {
          return detail?.assortmentStrategy === ASSORTMENT_STRATEGY && detail?.itemId === product?.itemId;
        }
      )
    )
  );
  return isDiscontinuedProduct || !!product?.availabilityType?.discontinued;
};

export const isOOS = ({ product }) => product?.isOOS;

export const isDiscontinuedItem = ({ product }) => product?.isDiscontinued;

export const isHiddenItem = ({ product }) => compareString(product?.identifiers?.hideItem, 'true');

export const isObsoleteItem = ({ product }) => product?.availabilityType?.obsolete;

export const bundleHasOOSProduct = ({ products }) =>
  products?.some((product) => isOOS({ product }));

export const bundleHasDiscontinuedProduct = ({ products }) =>
  products?.some((product) => product.isDiscontinued);

export const bundleHasHiddenProduct = ({ products }) =>
  products?.some((product) => isHiddenItem({ product }));

export const isProductUnavailable = ({ product }) => {
  if (!product) return false;
  return isOOS({ product })
    || isDiscontinuedItem({ product })
    || isHiddenItem({ product });
};

export const isBundleUnavailable = ({ products }) =>
  products?.some((product) => isProductUnavailable({ product }));

export const getAlertMessaging = ({ product, bundleProduct }) => {
  if (!product) return null;

  if (isOOS({ product })) {
    return BUNDLE_OOS_MESSAGE;
  }

  const isUnavailable = isProductUnavailable({ product });
  if (isUnavailable) {
    return bundleProduct?.features?.unavailableAlertMessageText;
  }

  return null;
};

const isUnavailableExperienceType = (product) => {
  const experienceType = getExperienceType(product);
  const bundleType = getBundleType(product);
  return UNAVAILABLE_EXPERIENCES.some(
    (exp) => exp.experienceType === experienceType && exp.bundleType === bundleType
  );
};

export const getFilterResponseFlag = (productData) => !isUnavailableExperienceType(productData);

export const showEmptyContainer = (bundleProduct, product) => {
  if (!bundleProduct?.features?.emptyContainerForUnavailableProduct) {
    return false;
  }
  return product?.removed || product?.isDiscontinued || isHiddenItem({ product });
};

export const getOOSProductIds = ({ products }) => {
  return products?.filter((product) => isOOS({ product }))
    ?.map((product) => product.itemId) || [];
};

export const isVariantUnavailable = (itemId, selectableVariantProducts, product) => {
  const filteredProduct = product?.itemId === itemId ? product
    : selectableVariantProducts?.find((selectableVariant) => selectableVariant?.itemId === itemId);
  return isProductUnavailable({ product: filteredProduct }) || false;
};